import React from 'react';
import { Link } from 'react-router-dom';
import TOLoginPageView from '../Views/TO/Login/LoginPageViewMobile';
import PasswordForm from '../Login/PasswordForm';
import JoinNow from '../Login/JoinNow';

import AppleButton from '../Views/TO/Login/AppleButton';
import GoogleButton from '../Views/TO/Login/GoogleButton';
import FacebookButton from '../Views/TO/Login/FacebookButton';

import AppVars from '../../AppVars.js';
import axios from 'axios';
import Loader from '../Loader';
import { parseURL, setCookies, delCookies, checkCookie, isValidGoToURL, validateSessionToken } from "account-portal-library/lib/helperFunctions";
import { withGotoUrl } from '../../withGotoUrl';
import { getGotoUrlFromCookies } from '../../gotoUrl';

import MfaSelectPage from './MfaSelectPage';
import MfaTextPage from './MfaTextPage';
import MfaEmailPage from './MfaEmailPage';
import MfaTrustPage from './MfaTrustPage';
import UnknownError from '../UnknownError.js';
import { getCallbacks, sendLoginPayload } from 'account-portal-library/lib/emailSignIn.js';
import navigateWithAnalytics from '../../analytics/navigateWithAnalytics.js';

const appVars = AppVars.getInstance();
const UNKNOWN_ERROR_URL = "/unknownerror";

class LoginPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      style: "TO",
      complete: false,
      payload: null,
      username: null,
      displayPhone: null,
      signInType: null,
      step: "",
      isUsernameExists: null,
      isAccountLocked: null,
      implicitGoogle: false,
      implicitFacebook: false,
      implicitApple: false,
      phoneNumber: null,
      acr_values: null,
      uid: null,
      successUrl: "",
    }
    this.saveSignInType = this.saveSignInType.bind(this);
    this.savePayload = this.savePayload.bind(this);
    this.saveUsername = this.saveUsername.bind(this);
    this.saveStep = this.saveStep.bind(this);
    this.saveDisplayPhone = this.saveDisplayPhone.bind(this);
    this.saveAccountLocked = this.saveAccountLocked.bind(this);
    this.saveUsernameExists = this.saveUsernameExists.bind(this);
    this.hideModalUsername = this.hideModalUsername.bind(this);
    this.hideModalLocked = this.hideModalLocked.bind(this);
    this.saveURI = this.saveURI.bind(this);
    this.savePhoneNumber = this.savePhoneNumber.bind(this);
    this.parseURL = this.parseURL.bind(this);
    this.checkCookie = this.checkCookie.bind(this);
  }

  async componentDidMount() {
    this.clearInfo();

    const url = window.location.search
    const urlParams = this.parseURL(url);

    if (urlParams.goto && isValidGoToURL("T", urlParams.goto)) {
      const gotoUrl = urlParams.goto;
      setCookies("goto", gotoUrl, "/", appVars.getDomain());
      this.setState({ successUrl: gotoUrl });
    }

    if ("provider" in urlParams) {
      const provider = urlParams.provider.toLowerCase();
      this.setState({
        implicitGoogle: provider === "google",
        implicitFacebook: provider === "facebook",
        implicitApple: provider === "apple"
      });
    }

    const hash = window.location.hash

    if (hash.includes("dg") || hash.includes("DG")) {
      sessionStorage.AP_STYLE = "DG"
      this.setState({ style: "DG" })
    } else {
      sessionStorage.AP_STYLE = "TO"
    }

    //Check if user already has a session cookie on their browser
    const checkCookieResponse = await this.checkCookie();

    if (checkCookieResponse.valid) {
      this.setState({ complete: true })
    }

    if ("acr_values" in urlParams && "goto" in urlParams) {
      try {
        const usernameId = checkCookieResponse?.uid || "";
        this.setState({ acr_values: urlParams.acr_values, uid: usernameId })
        if (urlParams.acr_values === "MFA") {
          const url = appVars.getBaseUrl() + "/" + appVars.getName() + '/json' + appVars.getRealm() + '/authenticate';
          const params = {
            'authIndexType': 'service',
            'authIndexValue': appVars.getMFATree(),
          };
          const headers = {
            'Accept-API-Version': 'resource=2.1',
            'Content-Type': 'application/json',
            ...(usernameId ? { 'x-username': usernameId } : {})
          };
          const authResponse = await getCallbacks(url, headers, params);
          if (authResponse.status !== 200) {
            throw authResponse.response;
          }
          if (authResponse?.response?.tokenId === "" && authResponse?.response?.successUrl === "/console") {
            const gotoUrl = getGotoUrlFromCookies(['T']);
            navigateWithAnalytics(gotoUrl, "cookie-redirect", "auto");
          }
          this.savePayload(authResponse?.response);
          const initialCallbacks = authResponse?.response?.callbacks || [];

          // checking the fingerprint payload
          if (initialCallbacks.length === 2 && initialCallbacks[1].type === "HiddenValueCallback") {
            authResponse.response.callbacks[1].input[0].value = `{"screen":{"screenWidth":${window.screen.width},"screenHeight":${window.screen.height},"screenColourDepth":${window.screen.colorDepth}},"timezone":{"timezone":"${new Date().getTimezoneOffset()}"},"plugins":{"installedPlugins":"internal-pdf-viewer;internal-pdf-viewer;internal-pdf-viewer;internal-pdf-viewer;internal-pdf-viewer;"},"fonts":{"installedFonts":"cursive;monospace;serif;sans-serif;fantasy;default;Arial;Arial Black;Arial Narrow;Bookman Old Style;Bradley Hand ITC;Century;Century Gothic;Comic Sans MS;Courier;Courier New;Georgia;Impact;Lucida Console;Monotype Corsiva;Papyrus;Tahoma;Times;Times New Roman;Trebuchet MS;Verdana;"},"userAgent":"${navigator.userAgent}","language":"${navigator.language}"}`;

            const fingerPrintResponse = await sendLoginPayload(authResponse.response, url, headers, params);
            if (fingerPrintResponse.status !== 200) {
              throw fingerPrintResponse.response;
            }
            this.savePayload(fingerPrintResponse.response);

            if (fingerPrintResponse.response.callbacks != null) {
              if (fingerPrintResponse.response.callbacks[0].type === 'PasswordCallback') {
                this.saveSignInType("PHONE");
                this.saveStep("PASSWORD");
              } else if (fingerPrintResponse.response.callbacks[0].type === 'ChoiceCallback') {
                this.saveStep("TRUST");
              }
              else {
                this.savePhoneNumber(fingerPrintResponse.response.callbacks[1].output[0].value);
                this.saveUsername(fingerPrintResponse.response.callbacks[0].output[0].value);
                const choiceResponse = await sendLoginPayload(fingerPrintResponse.response, url, headers, params);
                if (choiceResponse.status !== 200) {
                  throw choiceResponse.response;
                }
                this.savePayload(choiceResponse.response);
                const callbacksMapping = { 1: 'SELECT', 3: 'EMAIL_CODE' };
                this.saveStep(callbacksMapping[choiceResponse?.response?.callbacks.length] || "UNKNOWN");
              }
            } else {
              this.setState({ loading: true });
              const tokenValid = await this.checkToken(fingerPrintResponse.response);
              this.setState({ loading: false });
              if (tokenValid) {
                const gotoUrl = getGotoUrlFromCookies(['T']);
                navigateWithAnalytics(gotoUrl, "cookie-redirect", "auto");
              } else {
                navigateWithAnalytics(UNKNOWN_ERROR_URL, "error-redirect", "auto");
              }
            }
          }
          else {
            const callbacksMapping = { 1: "SELECT", 2: "USERNAME", 3: "EMAIL_CODE" };
            this.saveStep(callbacksMapping[initialCallbacks.length] || "UNKNOWN");
          }
        }
      } catch (errorResponse) {
        console.log("Error -> ", errorResponse);
        this.saveStep("USERNAME");
      }
    }
    else {
      this.saveStep("USERNAME");
    }
    this.setState({ loading: false })
  }

  parseURL(url) {
    const params = {};
    const searchParams = new URLSearchParams(new URL(url, window.location.origin).search);
    for (const [key, value] of searchParams.entries()) {
      params[key] = decodeURIComponent(value);
    }

    // If `goto` contains a nested query, parse that too
    if (params.goto) {
      try {
        const gotoParams = new URLSearchParams(new URL(params.goto).search);
        for (const [key, value] of gotoParams.entries()) {
          let decodedValue = decodeURIComponent(value);
          if (key === "acr_values") {
            decodedValue = decodedValue.replace(/\/$/, "");
          }
          params[key] = decodedValue;
        }
      } catch (e) {
        console.warn("Could not parse nested goto URL:", e);
      }
    }

    return params;
  }

  async checkToken(journeyResponse) {
    try {
      const tokenId = journeyResponse.tokenId;
      if (tokenId != null) {
        const validateResponse = await validateSessionToken(tokenId, appVars.getBaseUrl(), appVars.getName(), appVars.getRealm());
        return validateResponse.response.valid;
      } else {
        return false;
      }
    }
    catch {
      return false;
    }
  }

  async checkCookie() {
    try {
      const url = appVars.getBaseUrl() + "/" + appVars.getName() + "/json/realms/root/realms" + appVars.getRealm() + "/sessions?_action=validate&refresh=false";
      const headers = { 'Accept-API-Version': 'resource=2.1, protocol=1.0' };
      const checkCookieResponse = await axios({ headers, method: 'post', url });
      if (checkCookieResponse.status !== 200) {
        throw checkCookieResponse.response;
      }
      return checkCookieResponse?.data;
    } catch (errorResponse) {
      console.log("Error -> ", errorResponse);
    }
  }

  saveURI() {
    if (this.state.style === "DG") {
      setCookies("login_uri", window.location.href, "/", appVars.getDomain())
    }
  }

  clearInfo() {
    sessionStorage.removeItem("AP_SSID")
    sessionStorage.removeItem("AP_authId")
    delCookies("amlbcookie", "", "/", appVars.getDomain())
  }

  savePhoneNumber(value) {
    this.setState({ phoneNumber: value });
  }

  saveUsername(value) {
    this.setState({ username: value })
  }

  savePayload(value) {
    this.setState({ payload: value });
  }

  saveSignInType(value) {
    this.setState({ signInType: value });
  }

  saveStep(value) {
    this.setState({ step: value })
  }

  saveAccountLocked(value) {
    this.setState({ isAccountLocked: value })
  }

  saveUsernameExists(value) {
    this.setState({ isUsernameExists: value })
  }

  saveDisplayPhone(value) {
    this.setState({ displayPhone: value })
  }

  hideModalUsername(value) {
    this.setState({ isUsernameExists: null })
  }

  hideModalLocked(value) {
    this.setState({ isAccountLocked: null })
  }

  redirectToSuccessUrl() {
    /* Debug safety net to prevent duplicate redirects in STAGE
    if (window.__REDIRECT_DONE) {
      console.warn("REDIRECT_BLOCKED_ALREADY_DONE", window.location.href);
      return;
    }
    window.__REDIRECT_DONE = true;
    */
    navigateWithAnalytics(this.state.successUrl, "cookie-redirect", "auto");
  }

  render() {
    if (this.state.loading === true) {
      return <Loader />
    }
    //Redirect user if they already have a session cookie
    if (window === window.top && this.state.complete && this.state.successUrl && this.state.acr_values !== "MFA") {
      this.redirectToSuccessUrl();
      return null;
    } else if (this.state.implicitGoogle || this.state.implicitFacebook || this.state.implicitApple) {
      return (
        <div>
          {this.state.implicitGoogle === true && <GoogleButton implicitRegister={this.state.implicitGoogle} />}
          {this.state.implicitFacebook === true && <FacebookButton implicitRegister={this.state.implicitFacebook} />}
          {this.state.implicitApple === true && <AppleButton implicitRegister={this.state.implicitApple} />}
        </div>
      )
    } else {
      if (this.state.step === "USERNAME") {
        return (
          <TOLoginPageView
            payload={this.state.payload}
            username={this.state.username}
            isUsernameExists={this.state.isUsernameExists}
            isAccountLocked={this.state.isAccountLocked}
            displayPhone={this.state.displayPhone}
            savePayload={this.savePayload}
            saveDisplayPhone={this.saveDisplayPhone}
            saveSignInType={this.saveSignInType}
            saveUsername={this.saveUsername}
            saveStep={this.saveStep}
            saveAccountLocked={this.saveAccountLocked}
            saveUsernameExists={this.saveUsernameExists}
            hideModalLocked={this.hideModalLocked}
            hideModalUsername={this.hideModalUsername}
            style={sessionStorage.AP_STYLE}
            saveURI={this.saveURI}
            acr_values={this.state.acr_values}
            uid={this.state.uid}
          />
        )
      } else if (this.state.step === "JOIN") {
        return (
          <JoinNow style={this.state.style} username={this.state.username} />
        )
      } else if (this.state.step === "PASSWORD") {
        return (
          <PasswordForm style={this.state.style} username={this.state.username} signInType={this.state.signInType} savePayload={this.savePayload} saveStep={this.saveStep} payload={this.state.payload} savePhoneNumber={this.savePhoneNumber} saveUsername={this.saveUsername} acr_values={this.state.acr_values} uid={this.state.uid} />
        )
      } else if (this.state.step === "SELECT") {
        return (
          <MfaSelectPage style={this.state.style} savePayload={this.savePayload} payload={this.state.payload} saveStep={this.saveStep} username={this.state.username} phoneNumber={this.state.phoneNumber} />
        )
      } else if (this.state.step === "TEXT_CODE") {
        return (
          <MfaTextPage style={this.state.style} savePayload={this.savePayload} payload={this.state.payload} saveStep={this.saveStep} username={this.state.username} phoneNumber={this.state.phoneNumber} />
        )
      } else if (this.state.step === "EMAIL_CODE") {
        return (
          <MfaEmailPage style={this.state.style} savePayload={this.savePayload} payload={this.state.payload} saveStep={this.saveStep} username={this.state.username} />
        )
      } else if (this.state.step === "TRUST") {
        return (
          <MfaTrustPage style={this.state.style} savePayload={this.savePayload} payload={this.state.payload} saveStep={this.saveStep} />
        )
      } else if (this.state.step === "UNKNOWN") {
        return (<UnknownError />)
      }
    }
  }
}

export default withGotoUrl(LoginPage);